import React, {useContext} from 'react';
import PlayIcon from "./play-icon";
import GettingStartedContext from "../utils/GettingStartedContext";

const TestimonialsSection = () => {

  const {
    data,
    getProperty,
    isFr
  } = useContext(GettingStartedContext)

  let start = '"';
  let end = '"';
  if (isFr()) {
    start = '«';
    end = '»';
  }

  const options = data.Options;

  if (!options.Testimonial) {
    return null;
  }

  return <div className="gsa__testimonial gsa__testimonial--result">
    <div className="grid-container grid-container--gsa">
      <div className="grid-x">
        <div className="small-12 medium-offset-2 medium-8">
          <div className="gsa__testimonial__image">
            {!!options.TestimonialURL && <div className="img">
              <img src={options.TestimonialURL}/>
            </div>}
            {(options.Testimonial && options.Testimonial.VideoUrl) && <PlayIcon
              videoURL={options.Testimonial.VideoUrl}
            />}
          </div>

          <div className="gsa__testimonial__desc--result">
            <p>{start}{getProperty(options.Testimonial,'Content') }{end}</p>
            <p className="name">
              {getProperty(options.Testimonial,'Title') }
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
}

export default TestimonialsSection;
